import { parseDialogParams } from '../../lib/dialog';
import { parseSearchParams } from '../../lib/url';
import { enabled, waitForAuthorization } from '../../lib/who-am-i';
import { loadCountryOptions } from '../../queries/form-data';
import {
	loadCompanyItems,
	loadFilters,
	loadItemCategories,
	loadItemSubcategories,
	loadRewardRedemption,
	loadRewardRedemptions,
	loadRewards,
} from '../../queries/rewards';
import { createHistoryDetailParamParser, parseIndexParamsFromSearch } from './utils';
import { createIndexParamParser, formatIndexParams, getDefaultCategoryKey } from './utils-old';

export const loadRewardsHistory = async ({ request }: { request: Request }) => {
	const searchParams = new URL(request.url).searchParams;
	const params = parseSearchParams(searchParams, ...createHistoryDetailParamParser());
	const dialog = parseDialogParams(searchParams, 'redemption');

	const queries: Promise<any>[] = [
		loadRewardRedemptions({
			page_number: params.page,
			sort_by: params.sortBy,
			sort_direction: params.sortDirection,
		}),
	];

	if (dialog.isOpen && dialog.params.rewardId) {
		queries.push(loadRewardRedemption(dialog.params.rewardId));
	}

	return Promise.all(queries);
};

export const loadRewardsIndex = async ({ request }: { request: Request }) => {
	await waitForAuthorization();

	const isFilteringEnabled = enabled('rewards-filtering');

	if (isFilteringEnabled) {
		const [filters] = await Promise.all([loadFilters(), loadItemSubcategories(), loadCountryOptions()]);

		const search = new URL(request.url).search.slice(1);
		const params = parseIndexParamsFromSearch(search, filters.collections);

		return loadRewards(params);
	} else {
		const [categories, subCategories] = await Promise.all([loadItemCategories(), loadItemSubcategories(), loadCountryOptions()]);
		const defaultCategoryKey = getDefaultCategoryKey(categories);

		const params = parseSearchParams(new URL(request.url).searchParams, ...createIndexParamParser({ defaultCategoryKey, subCategories }));

		return loadCompanyItems(formatIndexParams(params, categories));
	}
};
